module.exports = __webpack_public_path__ + "img/aqi_lv5.db8825f2.png";